import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { Badge, Container, Grid, makeStyles, Typography } from '@material-ui/core'
import { isNil } from 'lodash'

import Collapse from '../../../../../UI/Collapse/Collapse'
import FeedbackHistory from '../../../../../Chat/ChatHistory/ChatHistory'

import FeedbackInput from './FeedbackInput/FeedbackInput'
import LoadingMask from '../../../../../../hoc/LoadingMask/LoadingMask'
import { ChatBubble } from '@material-ui/icons'

const useContainerStyle = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 1),
    maxHeight: 500,
    overflow: 'auto'
  }
}))

const FeedbackStructure = ({
  history,
  items,
  onItemExpanded,
  onFeedbackSubmit,
  onFeedbackFileClick,
  onFeedbackScroll,
  chatLoading,
  chatInputLoading,
  currentTabIndex,
  isAdmin
}) => {
  const containerClasses = useContainerStyle()
  const [activeItemIndex, setActiveItemIndex] = useState(null)

  const onItemExpandedHandler = useCallback(
    (activeIndex, data) => {
      setActiveItemIndex(prevIndex => {
        const newIndex = prevIndex === activeIndex ? null : activeIndex
        if (!isNil(newIndex)) {
          onItemExpanded(data)
        }

        return newIndex
      })
    },
    [onItemExpanded]
  )

  let feedbackInput = null
  if (!isAdmin) {
    feedbackInput = (
      <Grid item>
        <FeedbackInput onFeedbackSubmit={onFeedbackSubmit} loading={chatInputLoading} />
      </Grid>
    )
  }

  const collapseContent = useMemo(
    () => (
      <LoadingMask show={chatLoading}>
        <Grid container direction={'column'}>
          <Grid item>
            <FeedbackHistory
              chatKey={'feedback_id'}
              history={history}
              onFileClick={onFeedbackFileClick}
              onScroll={onFeedbackScroll}
            />
          </Grid>
          {feedbackInput}
        </Grid>
      </LoadingMask>
    ),
    [
      history,
      onFeedbackFileClick,
      onFeedbackScroll,
      chatLoading,
      feedbackInput
    ]
  )

  const itemCollapse = useMemo(
    () =>
      items.map((item, index) => {
        const shouldShowIcon = !!item.is_unread

        let label = item.item_name

        if (shouldShowIcon) {
          label = (
            <>
              <Badge color={'error'} variant={'dot'}>
                <Typography variant={'body2'}>{label}</Typography>
                <ChatBubble fontSize={'small'} />
              </Badge>
            </>
          )
        }
        return (
          <Collapse
            key={`${item.result_item_id}-${index}`}
            show={activeItemIndex === index}
            title={label}
            style={{ position: 'relative' }}
            toggleBarClicked={() => onItemExpandedHandler(index, item)}>
            {collapseContent}
          </Collapse>
        )
      }),
    [items, onItemExpandedHandler, collapseContent, activeItemIndex]
  )

  useEffect(() => {
    setActiveItemIndex(null)
  }, [currentTabIndex])

  return <Container classes={containerClasses}>{itemCollapse}</Container>
}

export default FeedbackStructure
